import { jsx as e } from "react/jsx-runtime";
import { UnstyledBlockContent as n } from "../UnstyledBlockContent/UnstyledBlockContent.js";
import { c as t } from "../clsx-OuTLNxxd.js";
const d = "FareCardRefundability-module_refundability__XjTOa",
  u = "FareCardRefundability-module_refundability-refundable__ox3uW",
  i = {
    refundability: d,
    refundabilityRefundable: u
  },
  y = _ref => {
    let {
      isRefundable: a,
      content: r,
      className: l
    } = _ref;
    return /* @__PURE__ */e("div", {
      className: t(i.refundability, {
        [i.refundabilityRefundable]: a
      }, l),
      children: /* @__PURE__ */e(n, {
        value: r
      })
    });
  };
export { y as FareCardRefundability };